module.exports = __webpack_public_path__ + "static/headerLogo-6bc918a121389454a2833db1b32951ad.png";